<template>
  <div
    id="pos-calendar-appointment"
    v-if="config.appointment_feature == 1"
    style="display: flex; flex-direction: column; height: 100vh"
    :class="{ 'is-full-screen': full_screen }"
  >
    <!-- <div class="flex align-center justify-between mb-6 pos-calendar-appointment-header" :class="{'mt-6': full_screen}">
      <div class="flex align-center">
        <div class="flex align-center button-group">
          <vs-button class="toggle-btn icon-btn" :class="{'active' : active_view == 'calendar'}" @click="changeActiveView('calendar')">
            <img src="../../assets/images/appointment/white-calendar-icon.svg" class="svg-icon" v-if="active_view == 'calendar'" />
            <img src="../../assets/images/appointment/primary-calendar-icon.svg" class="svg-icon"  v-else />
          </vs-button>
          <vs-button class="toggle-btn icon-btn" :class="{'active' : active_view == 'grid-view'}" @click="changeActiveView('grid-view')">
            <img src="../../assets/images/appointment/white-grid-view.svg" class="svg-icon" v-if="active_view == 'grid-view'" />
            <img src="../../assets/images/appointment/primary-grid-view.svg" class="svg-icon" v-else />
          </vs-button>
        </div>
        <vs-button class="ml-5 turn-btn" @click="handleTurnClick">TURN</vs-button>
      </div>
      <div class="flex align-center">
        <div class="flex align-center button-group">
          <vs-button class="toggle-btn filter-btn" :class="{'active': active_filter == 'processing'}" @click="changeActiveFilter('processing')">
            <div class="text-center">Processing</div>
            <div class="text-center">0</div>
          </vs-button>
          <vs-button class="toggle-btn filter-btn" :class="{'active': active_filter == 'cancelled'}" @click="changeActiveFilter('cancelled')">
            <div class="text-center">Cancelled</div>
            <div class="text-center">1</div>
          </vs-button>
          <vs-button class="toggle-btn filter-btn" :class="{'active': active_filter == 'done'}" @click="changeActiveFilter('done')">
            <div class="text-center">Done</div>
            <div class="text-center">0</div>
          </vs-button>
          <vs-button class="toggle-btn filter-btn" :class="{'active': active_filter == 'all'}" @click="changeActiveFilter('all')">
            <div class="text-center">All</div>
            <div class="text-center">1</div>
          </vs-button>
        </div>

        <div>
          <div class="flex-center date-filter">
            <date-picker class="ml-5 filter-date-picker" :format="date_format_string" v-model="currentDate" type="date" :editable="false" placeholder="Choose date" @change="selectedDate"></date-picker>
          </div>
        </div>
      </div>
    </div> -->
    <div class="h-full flex">
      <vx-card id="calendar-card">
        <div class="flex justify-between pt-1">
          <div class="flex justify-start">
            <vs-dropdown
              vs-trigger-click
              class="
                btn-dropdown-calendar
                staff-button
                rounded-item
                cursor-pointer
              "
              style="z-index: 101; position: relative"
              :class="{ 'no-resourse': !selectedResource }"
            >
              <a href.prevent v-if="selectedResource">
                <div
                  style="
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    min-width: 5px;
                    position: absolute;
                    top: 50%;
                    left: 5px;
                    transform: translateY(-50%);
                  "
                  :style="`background: ${
                    selectedResource.color_code
                      ? selectedResource.color_code
                      : '#2979FF'
                  }`"
                ></div>
                <div
                  class="
                    calendar-resource
                    border-left-custom
                    calendar-staff-filter
                  "
                >
                  <!-- <p :style="`max-width: ${show_waiting ? 7 : 15}vw`">
                    {{ selectedResource.title }}
                  </p> -->
                  <p style="max-width: 200px">{{ selectedResource.title }}</p>
                  <vs-icon class icon="expand_more"></vs-icon>
                </div>
              </a>
              <!-- <div class v-else> -->
              <a href.prevent v-else>
                <div class="calendar-staff-filter">
                  <p>Staffs</p>
                  <vs-icon class icon="expand_more"></vs-icon>
                </div>
              </a>
              <!-- </div> -->
              <vs-dropdown-menu
                style="font-size: 0.9em"
                class="staff-filter-dropdown-menu"
              >
                <span>
                  <vs-dropdown-item @click="selectSource()"
                    >Show all</vs-dropdown-item
                  >
                </span>
                <span v-for="resource in resources" :key="resource.id">
                  <vs-dropdown-item>
                    <div class="flex align-center">
                      <div
                        class="mx-2"
                        style="
                          width: 8px;
                          height: 8px;
                          border-radius: 50%;
                          min-width: 8px;
                        "
                        :style="`background: ${
                          resource.color_code ? resource.color_code : '#2979FF'
                        }`"
                      ></div>
                      <div
                        class="
                          calendar-resource
                          text-left
                          border-left-custom
                          py-1
                        "
                        @click="selectSource(resource)"
                      >
                        {{ resource.title }}
                      </div>
                    </div>
                  </vs-dropdown-item>
                </span>
              </vs-dropdown-menu>
            </vs-dropdown>
            <vs-dropdown
              vs-trigger-click
              class="
                btn-dropdown-calendar
                no-border-dropdown
                cursor-pointer
                filter-btn
              "
              style="z-index: 101"
            >
              <a class="btn-calendar" href.prevent>
                Filter
                <vs-icon class icon="expand_more"></vs-icon>
              </a>
              <vs-dropdown-menu style="font-size: 0.9em">
                <vs-dropdown-item>
                  <div
                    class="calendar-resource text-left"
                    @click="selectFilter('scheduled')"
                  >
                    <vs-checkbox v-model="filter_scheduled"
                      >Scheduled</vs-checkbox
                    >
                  </div>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <div
                    class="calendar-resource text-left"
                    @click="selectFilter('confirmed')"
                  >
                    <vs-checkbox v-model="filter_confirmed"
                      >Confirmed</vs-checkbox
                    >
                  </div>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <div
                    class="calendar-resource text-left"
                    @click="selectFilter('done')"
                  >
                    <vs-checkbox v-model="filter_done">Done</vs-checkbox>
                  </div>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <div
                    class="calendar-resource text-left"
                    @click="selectFilter('canceled')"
                  >
                    <vs-checkbox v-model="filter_canceled"
                      >Canceled</vs-checkbox
                    >
                  </div>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <span
                    class="calendar-resource text-left"
                    @click="selectFilter('clear')"
                  >
                    <div>Reset filter</div>
                  </span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <!-- <div v-if="$route.query.app != 1" class="btn-calendar">
              <feather-icon
                v-if="full_screen == false"
                icon="MaximizeIcon"
                svgClasses="h-6 w-6 text-primary cursor-pointer"
                style="transform: translateY(1px); z-index: 101"
                @click.stop="toggleFullScreen"
              />
              <feather-icon
                v-if="full_screen == true"
                icon="MinimizeIcon"
                svgClasses="h-6 w-6 text-primary cursor-pointer"
                style="transform: translateY(1px); z-index: 101"
                @click.stop="toggleFullScreen"
              />
            </div> -->
          </div>
          <!-- <vs-button
          class="btn-calendar"
          @click="popupAddNew"
          id="add-new-btn"
          style="z-index: 101"
        >Add new</vs-button>

        <vs-button
          class="btn-calendar"
          @click="popupBlockTime"
          id="add-new-btn"
          style="z-index: 101"
          >Block time</vs-button>-->
          <div class="flex justify-end">
            <!-- <vs-dropdown
              vs-trigger-click
              class="btn-dropdown-calendar no-border-dropdown"
              id="calendar-view-btn"
              style="z-index: 101"
            >
              <a class="btn-calendar" href.prevent>
                View by {{ currentView.name }}
                <vs-icon class icon="expand_more"></vs-icon>
              </a>
              <vs-dropdown-menu class="calendar-btn">
                <vs-dropdown-item
                  v-if="this.currentView.value != 'listWeek'"
                  @click="changeView('listWeek', 'List', '1w')"
                  >List</vs-dropdown-item
                >
                <vs-dropdown-item
                  v-if="this.currentView.value != 'resourceTimeGridDay'"
                  @click="changeView('resourceTimeGridDay', 'Day', '1d')"
                  >Day</vs-dropdown-item
                >
                <vs-dropdown-item
                  v-if="this.currentView.value != 'timeGridThreeDay'"
                  @click="changeView('timeGridThreeDay', '3 days', '3d')"
                  >3 days</vs-dropdown-item
                >
                <vs-dropdown-item
                  v-if="this.currentView.value != 'timeGridWeek'"
                  @click="changeView('timeGridWeek', 'Week', '1w')"
                  >Week</vs-dropdown-item
                >
                <vs-dropdown-item
                  v-if="this.currentView.value != 'dayGridMonth'"
                  @click="changeView('dayGridMonth', 'Month', '1m')"
                  >Month</vs-dropdown-item
                >
              </vs-dropdown-menu>
            </vs-dropdown> -->
            <!-- <div v-if="$route.query.app != 1" class="btn-calendar">
              <feather-icon
                v-if="full_screen == false"
                icon="MaximizeIcon"
                svgClasses="h-6 w-6 text-primary cursor-pointer"
                style="transform: translateY(1px); z-index: 101"
                @click.stop="toggleFullScreen"
              />
              <feather-icon
                v-if="full_screen == true"
                icon="MinimizeIcon"
                svgClasses="h-6 w-6 text-primary cursor-pointer"
                style="transform: translateY(1px); z-index: 101"
                @click.stop="toggleFullScreen"
              />
            </div> -->
            <a
              href.prevent
              @click="popupAddNewAppointment"
              class="staff-button rounded-item cursor-pointer mr-2"
              style="z-index: 101; padding: 10px; font-size: 0.9em"
              >Add Appointment</a
            >
            <!-- <vs-button @click="createOrder" class="add-new-btn"
              >New Order</vs-button
            > -->
            <!-- <vs-dropdown
              vs-trigger-click
              class="btn-dropdown-calendar"
              id="add-new-btn"
              style="z-index: 101;"
            >
              <vs-button class="btn-calendar gradient gradient-primary no-shadow">
                Add new
                <vs-icon class icon="expand_more"></vs-icon>
              </vs-button>
              <vs-dropdown-menu class="calendar-btn-add-new">
                <vs-dropdown-item @click="popupAddNew">New Appointment</vs-dropdown-item>
                <vs-dropdown-item @click="popupBlockTime">New Blocked Time</vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown> -->
          </div>
        </div>
        <!-- <div id="div-with-loading" class="vs-con-loading__container"> -->
        <div class="position-relative" id="my-relative-calendar">
          <datepicker
            class="my-input-calendar"
            v-model="currentDate"
            @selected="selectedDatePicker"
          ></datepicker>
          <FullCalendar
            id="div-with-loading"
            class="vs-con-loading__container"
            name="fullcalendar"
            defaultView="resourceTimeGridDay"
            :defaultDate="defaultDate"
            :resourceColumns="resourceColumns"
            :plugins="calendarPlugins"
            :header="calendarHeader"
            :customButtons="calendarCustomButtons"
            :weekends="true"
            @dateClick="handleDateClick"
            :views="views"
            :nowIndicator="true"
            :events="events"
            :businessHours="businessHours"
            @eventClick="handleEventClick"
            :editable="editable"
            :droppable="editable"
            @eventDrop="handleEventDrop"
            :eventDurationEditable="false"
            :datesRender="datesRender"
            :resources="resources"
            resourceOrder="index"
            :slotEventOverlap="false"
            :resourceEventOverlap="false"
            :selectOverlap="false"
            :eventOverlap="false"
            :allDaySlot="false"
            :minTime="minTime"
            :maxTime="maxTime"
            :slotDuration="slotTime"
            slotLabelInterval="01:00:00"
            aspectRatio="1.68"
            :scrollTime="scrollNow"
            nextDayThreshold="03:00:00"
            ref="calendar"
            style="transform: translateY(-43px); z-index: 100"
            @eventMouseEnter="handleEventMouseEnter"
            @eventMouseLeave="handleEventMouseLeave"
            :eventRender="handleEventRender"
            @drop="handleWaitItemDrop"
            :slotWidth="90"
            resourceAreaWidth="130px"
          />
        </div>
        <!-- </div> -->
      </vx-card>
      <div
        class="vertical-line"
        :class="{ 'hide-waiting-list': !show_waiting }"
      >
        <div class="toggle-waiting-list">
          <img
            src="../../assets/images/hide-waiting-list-icon.png"
            class="cursor-pointer"
            @click.stop="toggleWaitingList"
          />
        </div>
      </div>
      <vx-card
        id="wait-list-card"
        class="w-1/2 position-relative"
        :class="{ 'hide-waiting-list': !show_waiting }"
      >
        <!-- <div class="toggle-waiting-list">
          <img
            src="../../assets/images/hide-waiting-list-icon.png"
            class="cursor-pointer"
            @click.stop="toggleWaitingList"
          />
        </div> -->
        <div class="flex align-center justify-between mb-10">
          <h3 class="font-bold">WAIT</h3>
          <vs-switch
            v-model="active_waiting"
            @click="updateActiveWaitList"
          ></vs-switch>
        </div>
        <div class="flex wait-list">
          <div class="w-1/2 wait-list-col pr-1">
            <h5 class="font-bold mb-4">
              Walk <span v-if="containerEl">In</span><span v-else>in</span>
            </h5>
            <div class="col-content walk-in-col-content">
              <div class="h-full overflow-auto">
                <div
                  v-for="(item, index) in walkinWaitList"
                  :key="index"
                  class="w-full position-relative card-item-relative"
                >
                  <vx-card
                    class="no-shadow border-custom drag-item"
                    :class="{
                      'mt-4': index != 0,
                      'mb-4': index != walkinWaitList.length - 1,
                    }"
                    @click="waitListClick(item)"
                    :id="item.id"
                  >
                    <h5 class="px-1 font-bold break-word" v-if="item.customer">
                      {{ item.customer.full_name }}
                    </h5>
                    <div class="px-1 text-grey-custom" v-if="item.customer">
                      <feather-icon
                        icon="PhoneIcon"
                        svgClasses="h-4 w-4 mr-1 font-bold"
                      />
                      <span class="text-sm">{{
                        StringHelper.phoneNumberFormat(
                          item.customer.phone,
                          true
                        )
                      }}</span>
                    </div>
                    <div class="px-1 text-sm text-primary my-1">
                      <span class="d-inline-block mr-2">{{
                        changeDateFormat(item.create_at)
                      }}</span>
                      <span>{{ changeTimeFormat(item.create_at) }}</span>
                    </div>
                    <div
                      class="
                        border-top-custom
                        pt-2
                        text-sm text-black
                        flex
                        staff-service-list
                      "
                    >
                      <div class="w-1/2 pr-2 border-right-custom">
                        <div v-if="item.services && item.services.length > 0">
                          <div
                            v-for="(service, i) in item.services"
                            :key="i"
                            style="line-height: 1.2"
                            class="break-word"
                            :class="{ 'mb-3': i != item.services.length - 1 }"
                          >
                            {{ service.name }}
                          </div>
                        </div>
                      </div>
                      <div class="w-1/2 pl-2">
                        <div v-if="item.staffs && item.staffs.length > 0">
                          <div
                            v-for="(staff, i) in item.staffs"
                            :key="i"
                            style="line-height: 1.2"
                            class="break-word"
                            :class="{ 'mb-3': i != item.staffs.length - 1 }"
                          >
                            {{ staff.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                  <div
                    class="tooltip"
                    style="
                      position: absolute;
                      bottom: 0;
                      left: 50%;
                      transform: translateX(-50%);
                    "
                    @click.stop
                  >
                    <vs-button class="more-action" @click.stop>
                      <div
                        v-for="dot in 3"
                        :key="dot"
                        style="
                          width: 3px;
                          height: 3px;
                          border-radius: 50%;
                          background: #272727;
                          margin: 1px;
                        "
                      ></div>
                      <span
                        class="tooltiptext"
                        style="word-wrap: break-word; word-break: break-word"
                      >
                        <div
                          class="item-action"
                          @click.stop="cancelWaitingItem(item)"
                        >
                          <div class="flex-center text-danger">
                            <feather-icon
                              icon="XCircleIcon"
                              svgClasses="w-4 h-4 stroke-current text-danger mr-2"
                            />CANCEL
                          </div>
                        </div>
                      </span>
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-1/2 wait-list-col pl-1">
            <h5 class="font-bold mb-4">Appointment</h5>
            <div class="col-content appointment-col-content">
              <div class="h-full overflow-auto">
                <div
                  v-for="(item, index) in appointmentWaitList"
                  :key="index"
                  class="w-full position-relative card-item-relative"
                >
                  <vx-card
                    class="no-shadow border-custom drag-item"
                    :class="{
                      'mt-4': index != 0,
                      'mb-4': index != appointmentWaitList.length - 1,
                    }"
                    @click="waitListClick(item)"
                    :id="item.id"
                  >
                    <h5 class="px-1 font-bold break-word" v-if="item.customer">
                      {{ item.customer.full_name }}
                    </h5>
                    <div class="px-1 text-grey-custom" v-if="item.customer">
                      <feather-icon
                        icon="PhoneIcon"
                        svgClasses="h-4 w-4 mr-1 font-bold"
                      />
                      <span class="text-sm">{{
                        StringHelper.phoneNumberFormat(
                          item.customer.phone,
                          true
                        )
                      }}</span>
                    </div>
                    <div class="px-1 text-sm text-primary my-1">
                      <span class="d-inline-block mr-2">{{
                        changeDateFormat(item.create_at)
                      }}</span>
                      <span>{{ changeTimeFormat(item.create_at) }}</span>
                    </div>
                    <div
                      class="
                        border-top-custom
                        pt-2
                        text-sm text-black
                        flex
                        staff-service-list
                      "
                    >
                      <div class="w-1/2 pr-2 border-right-custom">
                        <div v-if="item.services && item.services.length > 0">
                          <div
                            v-for="(service, i) in item.services"
                            :key="i"
                            style="line-height: 1.2"
                            class="break-word"
                            :class="{ 'mb-3': i != item.services.length - 1 }"
                          >
                            {{ service.name }}
                          </div>
                        </div>
                      </div>
                      <div class="w-1/2 pl-2">
                        <div v-if="item.staffs && item.staffs.length > 0">
                          <div
                            v-for="(staff, i) in item.staffs"
                            :key="i"
                            style="line-height: 1.2"
                            class="break-word"
                            :class="{ 'mb-3': i != item.staffs.length - 1 }"
                          >
                            {{ staff.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                  <div
                    class="tooltip"
                    style="
                      position: absolute;
                      bottom: 0;
                      left: 50%;
                      transform: translateX(-50%);
                    "
                    @click.stop
                  >
                    <vs-button class="more-action" @click.stop>
                      <div
                        v-for="dot in 3"
                        :key="dot"
                        style="
                          width: 3px;
                          height: 3px;
                          border-radius: 50%;
                          background: #272727;
                          margin: 1px;
                        "
                      ></div>
                      <span
                        class="tooltiptext"
                        style="word-wrap: break-word; word-break: break-word"
                      >
                        <div
                          class="item-action"
                          @click.stop="cancelWaitingItem(item)"
                        >
                          <div class="flex-center text-danger">
                            <feather-icon
                              icon="XCircleIcon"
                              svgClasses="w-4 h-4 stroke-current text-danger mr-2"
                            />CANCEL
                          </div>
                        </div>
                      </span>
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="drag-item">abc</div> -->
      </vx-card>
    </div>
    <pos-appointment-popup
      :config="popupConfig"
      @closePopup="closePopup"
      @edit="editAppointment"
      :key="popupConfig.appointmentId + popupConfig.key"
    />
    <pos-appointment-edit-popup
      v-if="popupEditConfig.isActive"
      :config="popupEditConfig"
      @closePopup="closeEditPopup"
      :key="popupEditConfig.key"
    />
    <appointment-edit-popup
      v-if="popupEditConfigBase.isActive"
      :config="popupEditConfigBase"
      @closePopup="closeEditPopupBase"
      @closePopupFromIcon="closePopupFromIcon"
      :key="popupEditConfigBase.key"
    />
    <block-time-popup
      :config="popupBlockTimeConfig"
      @closePopup="closeBlockTimePopup"
      :key="popupBlockTimeConfig.key"
    />
    <vs-prompt
      title="Confirmation"
      @accept="acceptAlert"
      :active.sync="activePrompt"
      accept-text="Continue"
      color="success"
      cancel-text="Delete"
      @cancel="deleteAlert"
    >
      <div class="con-exemple-prompt">{{ promptContent }}</div>
    </vs-prompt>
    <!-- <vs-prompt
      title="Confirmation"
      @accept="acceptUpdateEvent"
      :active.sync="activeUpdateEventPrompt"
      accept-text="Continue"
      color="success"
      cancel-text="Cancel"
      @cancel="cancelUpdateEvent"
    >
      <div class="con-exemple-prompt">{{ updateEventPromptContent }}</div>
    </vs-prompt> -->

    <!-- <search-appointment-popup
      :searchAppointmentConfig="searchAppointmentConfig"
    ></search-appointment-popup> -->
  </div>
  <div v-else-if="config.appointment_feature == 0">
    <vx-card style="flex: 15%">
      <h2>
        This is for Go Booking full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import listPlugin from "@fullcalendar/list";
import PosAppointmentPopup from "./PosAppointmentPopup";
import PosAppointmentEditPopup from "./PosAppointmentEditPopup";
import AppointmentEditPopup from "./AppointmentEditPopup";
import BlockTimePopup from "./BlockTimePopup";
import moment from "moment";
import { EventSourcePolyfill } from "event-source-polyfill";
import { domain, client_id } from "../../axios";
import * as md5 from "md5";
import SearchAppointmentPopup from "./SearchAppointmentPopup";
import Datepicker from "vuejs-datepicker";
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { StringHelper } from "../../models/string_helper";
import {
  formatWaitListDate,
  formatDateString,
} from "../../helper/datetimeHelper";

export default {
  components: {
    FullCalendar,
    PosAppointmentPopup,
    PosAppointmentEditPopup,
    AppointmentEditPopup,
    BlockTimePopup,
    SearchAppointmentPopup,
    Datepicker,
    // DatePicker,
  },
  props: {
    dataChange: {
      type: Object,
    },
    searchAppointmentConfig: {
      type: Object,
    },
  },
  created() {
    let obj = {
      key: "config.pos.checkin_to_wait_list",
    };

    this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", obj)
      .then(() => {
        let active_waiting = this.$store.getters["appSetting/keyStorage"];
        this.active_waiting = active_waiting.value == 1 ? true : false;
        this.show_waiting = this.active_waiting;
      })
      .catch(() => {
        let create_obj = {
          key: "config.pos.checkin_to_wait_list",
          value: 1,
        };
        this.$store.dispatch("appSetting/ADD_KEY_STORAGE", create_obj);
      });
    this.subscribeTopic();
    this.$store.dispatch("auth/GET_USER_INFO");
    this.$store.dispatch("service/GET_SERVICE_LIST");
    this.$store.dispatch("staff/GET_STAFF_LIST");
    this.$store.dispatch("customer/GET_CUSTOMER_LIST");
    this.$store.dispatch("business/GET_WORKING_HOUR", { business_id: 1 });
    if(this.$mqttClient) {
      // this.doSubscribe();
      this.$mqttClient.on("message", (topic, message) => {
        // console.log(`Received message ${message} from topic ${topic}`);
        if(message && topic && this.config && this.config.mqtt) {
          if(topic == `/gci/${this.config.mqtt.id}/appointment/update`) {
            this.$store.dispatch("posAppointment/RELOAD_CALENDAR");
          }
          if(topic == `/gci/${this.config.mqtt.id}/checkin/update`) {
            this.$store.dispatch("posAppointment/GET_WAIT_LIST");
          }
        }
      })
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.setPositionOfMiniCalendar();
    // }, 1000)
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      // let containerEl = document.getElementById("wait-list-card");

      // if (containerEl) {
      //   this.containerEl = containerEl;
      //   new Draggable(containerEl, {
      //     itemSelector: ".drag-item",
      //   });
      // }
      document
        .getElementsByTagName("body")[0]
        .addEventListener("mousemove", (e) => {
          this.element = document.elementFromPoint(e.x, e.y);
          // this.mousePos = { x: e.x, y: e.y };
        });

      if (typeof window.chrome.webview !== "undefined") {
        window.chrome.webview.removeEventListener("message");
        window.chrome.webview.addEventListener("message", this.handleMessage);
      }
    });
    window.goToDate = (date) => {
      let calendarApi = this.$refs.calendar.getApi();
      calendarApi.gotoDate(date);
    };
  },
  // updated() {
  //   this.$nextTick(() => {
  //     let containerEl = document.getElementById("wait-list-card");

  //     if (containerEl) {
  //       console.log(containerEl);
  //       new Draggable(containerEl, {
  //         itemSelector: ".drag-item",
  //       });
  //     }
  //   });
  // },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        if(this.config && this.config.mqtt && this.subscribeSuccess == false) {
          this.subscription = {
            // topic: `/gci/${this.config.mqtt.id}/appointment/update`,
            topic: `/gci/${this.config.mqtt.id}/+/update`,
            qos: 0,
          };
          this.doSubscribe();
        }
      }
    },
    // config: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     if(this.config && this.config.appointment_feature != 0 && this.config.appointment_feature != 1) {
    //       this.openLoadingInDiv();
    //     } else {
    //       this.closeLoading();
    //     }
    //   }
    // },
    dataChange: {
      immediate: true,
      deep: true,
      handler: function () {
        // if(this.dataChange) {
        //   console.log(this.dataChange.message);
        // }
        // if(this.dataChange && this.dataChange.message == 'afterInsert') {
        if (this.dataChange && this.dataChange.message != "") {
          this.$store.dispatch("service/GET_SERVICE_LIST");
          this.$store.dispatch("staff/GET_STAFF_LIST");
          this.$store.dispatch("customer/GET_CUSTOMER_LIST");
          this.$store.dispatch("business/GET_WORKING_HOUR", { business_id: 1 });
          this.$store.dispatch("posAppointment/RELOAD_CALENDAR");
        }
      },
    },
    $route: {
      handler: function (route) {
        // console.log(route);
        if (route.params.id) {
          this.closePopup();
          this.$store
            .dispatch("posAppointment/GET_APPOINTMENT_DETAIL", {
              id: route.params.id,
            })
            .then(() => {
              this.openDetailPopup(route.params.id);
            })
            .catch((error) => {
              this.$vs.dialog({
                color: "danger",
                title: "Appointment detail",
                text: error,
                acceptText: "OK",
              });
            });
        }
      },
      deep: true,
      immediate: true,
    },
    myWindowWidth: {
      immediate: true,
      handler() {
        if (this.full_screen) {
          let navbar = document.getElementById("my-navbar-container");
          let my_vertical_nav_menu = document.getElementById(
            "my-vertical-nav-menu"
          );
          let content_area = document.getElementById("content-area");
          let router_view = document.getElementById("my-router-view");
          let router_content = document.getElementById("my-router-content");
          
          if(navbar && my_vertical_nav_menu && content_area && router_view && router_content) {
            navbar.classList.add("d-none");
            my_vertical_nav_menu.classList.add("d-none");
            content_area.classList.add("m-0");
            router_view.classList.add("p-0");
            router_content.classList.add("mt-0");
          }
        }
        this.setPositionOfMiniCalendar();
      },
    },
    change_date_value_key: {
      immediate: true,
      handler() {
        this.setPositionOfMiniCalendar();
      },
    },
    // active_waiting: {
    //   immediate: true,
    //   handler() {
    //     this.show_waiting = this.active_waiting;
    //   }
    // }
    waitList: {
      immediate: true,
      deep: true,
      handler() {
        // setTimeout(() => {
        //   this.createDraggable();
        // }, 500);
        if (this.waitList && this.waitList.length > 0) {
          this.wait_list_key++;
          if (this.wait_list_key == 1) {
            this.createDraggable();
          }
        }
      },
    },
    // wait_list_key: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     this.createDraggable();
    //   }
    // }
    // currentDate: {
    //   immediate: true,
    //   handler() {
    //     console.log(this.currentDate);

    //   }
    // }
  },
  data() {
    let date_format_string = formatDateString();
    let full_screen = false;
    if (this.$route.query.app == 1) {
      full_screen = true;
    }
    return {
      //Config for edit popup
      date_format_string,
      StringHelper,
      popupEditConfig: {
        isActive: false,
        isNewEvent: true,
        appointmentId: null,
        initDate: null,
        key: 0,
        staff_id: null,
      },
      popupEditConfigBase: {
        isActive: false,
        isNewEvent: true,
        appointmentId: null,
        initDate: null,
        key: 40000,
        staff_id: null,
      },
      //Config for information popup
      popupConfig: {
        isActive: false,
        appointmentId: null,
        key: 10000,
      },
      popupBlockTimeConfig: {
        isActive: false,
        key: 30000,
      },
      calendarPlugins: [
        dayGridPlugin,
        resourceTimelinePlugin,
        interactionPlugin,
        timeGridPlugin,
        resourceTimeGridPlugin,
        listPlugin,
      ],
      calendarHeader: {
        left: "",
        center: "prev,today,title,next",
        right: "",
      },
      views: {
        timeGridThreeDay: {
          type: "timeGrid",
          duration: { days: 3 },
          buttonText: "3 day",
          slotEventOverlap: false,
        },
        dayGridMonth: {
          eventLimit: 4,
        },
        timeGridWeek: {
          slotEventOverlap: false,
        },
        resourceTimeGridDay: {
          titleFormat: {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
          },
        },
        resourceDayGridDay: {
          titleFormat: {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
          },
        },
      },
      currentView: {
        name: "Day",
        value: "resourceDayGridDay",
      },
      calendarCustomButtons: {},
      scrollNow: moment().add("-2", "hours").format("HH:00:00"),
      activePrompt: false,
      promptContent: "",
      promptEvent: {},
      argPopup: null,
      filter_scheduled: true,
      filter_confirmed: true,
      filter_canceled: false,
      filter_done: true,
      string_params: "",
      full_screen,
      interval: null,
      lastAppointment: null,
      myWindowWidth: 0,
      currentDate: this.$route.query.date
        ? new Date(this.$route.query.date)
        : new Date(),
      defaultDate: this.$route.query.date
        ? new Date(this.$route.query.date)
        : new Date(),
      resourceColumns: [{ labelText: "Staffs" }],
      change_date_value_key: 0,
      editable: true,
      active_waiting: true,
      show_waiting: true,
      containerEl: null,
      wait_list_key: 0,
      active_view: "calendar",
      active_filter: "processing",
      isOpenLoading: false,
      element: null,
      elementPosition: [
        {
          scrollClass: ".fc-time-grid-container",
          class: ".fc-resourceTimeGridDay-view",
        },
        {
          scrollClass: ".walk-in-col-content > .overflow-auto",
          class: ".walk-in-col-content",
        },
        {
          scrollClass: ".appointment-col-content > .overflow-auto",
          class: ".appointment-col-content",
        },
        {
          scrollClass: ".customer-list-search-scroll",
          class: ".customer-list-search-scroll",
        },
        {
          scrollClass: ".start-time-select .vs__dropdown-menu",
          class: ".start-time-select",
          isSelect: true,
        },
        {
          scrollClass: ".add-appointment__dropdown .vs-dropdown--menu",
          class: ".add-appointment__dropdown",
          isSelect: true,
        },
        {
          scrollClass: ".duration-select .vs__dropdown-menu",
          class: ".duration-select",
          isSelect: true,
        },
        // {
        //   scrollClass: ".right-content .mini-scroll",
        //   class: ".mini-scroll"
        // },
        {
          scrollClass: ".customer-tabs .vs-tabs--content",
          class: ".customer-tabs",
        },
        {
          scrollClass:
            ".add-popup-content > .position-relative > .overflow-auto",
          class: ".add-popup-content",
        },
        {
          scrollClass: ".popup-service-scroll",
          class: ".popup-service-scroll",
        },
        {
          scrollClass: ".checkout-staff-popup-scroll",
          class: ".checkout-staff-popup-scroll",
        },
        {
          scrollClass: ".staff-filter-dropdown-menu > .vs-dropdown--menu",
          class: ".staff-filter-dropdown-menu",
        },
      ],
      subscription: {
        topic: "/gci/{id}/appointment/update",
        qos: 0,
      },
      subscribeSuccess: false
      // mousePos: { x: 0, y: 0 }
      // activeUpdateEventPrompt: false,
      // updateEventPromptContent: ""
      // pen_clicked: false
    };
  },
  computed: {
    events() {
      // console.log(this.$store.getters["posAppointment/filteredList"]);
      return this.$store.getters["posAppointment/filteredList"];
    },
    resources() {
      // console.log(this.$store.getters["posAppointment/resourceList"]);
      return this.$store.getters["posAppointment/resourceList"];
    },
    businessHours() {
      if (this.$store.getters["business/workingHour"] != null) {
        return this.$store.getters["business/workingHour"].working_hour;
      } else {
        return [];
      }
    },
    minTime() {
      let data = this.businessHours;
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].daysOfWeek && data[i].daysOfWeek[0] == moment(this.currentDate).day()) {
            // return data[i].startTime;
            let time = moment(data[i].startTime, 'HH:mm:ss');
            let before_time = moment(time).add("-1", "hours");
            
            let result = before_time.format("HH:mm:ss");
            
            if ((time.hours() * 60 + time.minutes()) < before_time.hours() * 60 + before_time.minutes()) {
              result = "00:00:00";
            }

            return result;
          }
        }
      }
      return "06:00:00";
    },
    maxTime() {
      let data = this.businessHours;
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].daysOfWeek && data[i].daysOfWeek[0] == moment(this.currentDate).day()) {
            // return data[i].endTime;
            let time = moment(data[i].endTime, 'HH:mm:ss');
            let after_time = moment(time).add("1", "hours");
            
            let result = after_time.format("HH:mm:ss");
            
            if ((time.hours() * 60 + time.minutes()) > after_time.hours() * 60 + after_time.minutes()) {
              result = "24:00:00";
            }
            
            return result;
          }
        }
      }
      return "22:00:00";
    },
    waitList() {
      return this.$store.getters["posAppointment/waitList"];
    },
    walkinWaitList() {
      return this.$store.getters["posAppointment/walkinWaitList"];
    },
    appointmentWaitList() {
      return this.$store.getters["posAppointment/appointmentWaitList"];
    },
    selectedResource() {
      return this.$store.getters["posAppointment/selectedResource"];
    },
    appointmentDetail() {
      return this.$store.getters["posAppointment/appointmentDetail"];
    },
    config() {
      return this.$store.getters["auth/config"];
    },
    slotTime() {
      let minutes = parseInt(
        this.$store.getters["auth/config"].calendar_split_time
      );
      if (isNaN(minutes)) {
        minutes = 15;
      }
      return minutes * 60000;
    },
  },
  methods: {
    doSubscribe() {
      const { topic, qos } = this.subscription;
      this.$mqttClient.subscribe(topic, { qos }, (error, res) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        this.subscribeSuccess = true;
        console.log("Subscribe to topics res", res);
      });
    },
    doUnSubscribe() {
      const { topic } = this.subscription;
      // this.client.unsubscribe(topic, (error) => {
      this.$mqttClient.unsubscribe(topic, (error) => {
        this.subscribeSuccess = false;
        if (error) {
          console.log("Unsubscribe error", error);
        }
      });
    },
    handleMessage(message) {
      // console.log(message.data.data.scroll_delta_dy);
      // console.log(message);
      // let evt = document.createEvent("MouseEvents");
      // evt.initEvent("wheel", true, true);
      // evt.deltaY = message.data.data.scroll_delta_dy;
      // console.log(evt);
      // this.element.dispatchEvent(evt);
      let direction = message.data.data.scroll_delta_dy > 0 ? -1 : 1;
      for (let i = 0; i < this.elementPosition.length; i++) {
        // if(item.data && item.data.top < this.mousePos.y && item.data.bottom > this.mousePos.y && item.data.left < this.mousePos.x && item.data.right > this.mousePos.x) {
        //   let elem = document.querySelectorAll(item.scrollClass);
        //   if(elem && elem[0]) {
        //     elem[0].scrollTop += distance;
        //   }
        // }
        let item = this.elementPosition[i];
        let item_class = item.class.replace(".", "");
        let distance = 40;
        if (this.upTo(this.element, item_class)) {
          let elems = document.querySelectorAll(item.scrollClass);
          if (elems && elems[0]) {
            if (item.isSelect) {
              distance = 20;
            }
            elems.forEach((elem) => {
              elem.scrollTop += direction * distance;
            });
          }
          break;
        }
      }
    },
    upTo(el, className) {
      while (el && el.parentNode) {
        el = el.parentNode;
        if (el.classList && el.classList.contains(className)) {
          return el;
        }
      }
      return null;
    },
    // getElementPosition() {
    //   if(this.elementPosition && this.elementPosition.length > 0) {
    //     this.elementPosition.forEach((item) => {
    //       let elem = document.querySelectorAll(item.class);
    //       if (elem && elem[0]) {
    //         item.data = elem[0].getBoundingClientRect();
    //       }
    //     })
    //     console.log(this.elementPosition);
    //   }
    // },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8,
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Get data failed",
            acceptText: "OK",
          });
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    async updateActiveWaitList() {
      this.active_waiting = !this.active_waiting;
      this.$vs.dialog({
        color: "warning",
        title: `Confirmation!`,
        type: "confirm",
        text: `Do you want to ${
          !this.active_waiting ? "inactive" : "active"
        } the wait list?`,
        accept: async () => {
          let obj = {
            key: "config.pos.checkin_to_wait_list",
            value: !this.active_waiting ? 1 : 0,
          };
          await this.$vs.loading({
            container: "#app",
            scale: 0.8,
          });

          this.$store
            .dispatch("appSetting/UPDATE_KEY_STORAGE", obj)
            .then(() => {
              this.active_waiting = !this.active_waiting;
              this.show_waiting = this.active_waiting;
              this.$vs.loading.close("#app > .con-vs-loading");
              this.$vs.notify({
                title: "Notification",
                text: `${
                  this.active_waiting ? "Active" : "Inactive"
                } Wait List Success`,
                color: "success",
                position: "top-right",
              });
            })
            .catch((err) => {
              console.log("Error: ", err);
              this.$vs.loading.close("#app > .con-vs-loading");
            });
        },
        cancel: () => {},
      });
    },
    createDraggable() {
      let containerEl = document.getElementById("wait-list-card");

      // console.log(containerEl);
      this.containerEl = null;
      if (containerEl) {
        this.containerEl = containerEl;
        new Draggable(containerEl, {
          itemSelector: ".drag-item",
        });
      }
    },
    changeDateFormat(date) {
      if (date) {
        return formatWaitListDate(date);
      }
      return "N/A";
    },
    changeTimeFormat(date) {
      if (date) {
        return moment(date).format("hh:mm A");
      }
      return "";
    },
    onResize() {
      this.myWindowWidth = window.innerWidth;
      // this.setPositionOfMiniCalendar();
      setTimeout(() => {
        this.setPositionOfMiniCalendar();
      }, 500);
      // this.setMyCalendarTableHeader();
    },
    setPositionOfMiniCalendar() {
      let elem = document.querySelector("#div-with-loading h2");
      let my_input = document.querySelector(".my-input-calendar");
      if (elem && my_input) {
        let calendar = document.querySelector("#div-with-loading");
        let calendar_pos = calendar.getBoundingClientRect();
        let elem_pos = elem.getBoundingClientRect();
        my_input.style.width = elem.clientWidth + "px";
        my_input.style.left = elem_pos.left - calendar_pos.left + "px";
      }

      // let calendar = document.getElementById("my-relative-calendar");
      // let wait_col = document.querySelectorAll(".col-content");
      // if (calendar && wait_col) {
      //   for (let i = 0; i < wait_col.length; i++) {
      //     wait_col[i].style.height = calendar.clientHeight + "px";
      //   }
      // }
    },
    toggleWaitingList() {
      this.show_waiting = !this.show_waiting;
      setTimeout(() => {
        this.setPositionOfMiniCalendar();
      }, 500);
    },
    waitListClick(item) {
      if (item.order) {
        alert("Order id: " + item.order.id);
        if (typeof window.chrome.webview !== "undefined") {
          window.chrome.webview.postMessage({
            app: "pos-appointment",
            type: "click",
            action: "update-order",
            data: { order_id: item.order.id },
          });
        }
      } else {
        alert("Khong co order nha");
      }
    },
    toggleFullScreen() {
      let navbar = document.getElementById("my-navbar-container");
      let my_vertical_nav_menu = document.getElementById(
        "my-vertical-nav-menu"
      );
      let content_area = document.getElementById("content-area");
      let router_view = document.getElementById("my-router-view");
      let router_content = document.getElementById("my-router-content");

      if (!this.full_screen) {
        this.full_screen = true;
        navbar.classList.add("d-none");
        my_vertical_nav_menu.classList.add("d-none");
        content_area.classList.add("m-0");
        router_view.classList.add("p-0");
        router_content.classList.add("mt-0");
      } else {
        this.full_screen = false;
        navbar.classList.remove("d-none");
        my_vertical_nav_menu.classList.remove("d-none");
        content_area.classList.remove("m-0");
        router_view.classList.remove("p-0");
        router_content.classList.remove("mt-0");
      }
      setTimeout(() => {
        this.setPositionOfMiniCalendar();
      }, 500);
    },
    // dayRenderCallback() {
    //   setTimeout(
    //     () =>
    //       this.$el.querySelector("h2").addEventListener("click", () => {
    //         this.openDatePicker();
    //       }),
    //     0
    //   );
    //   console.log();
    // },
    // openDatePicker() {
    //   console.log("open date picker");
    // },
    selectedDate(date) {
      if (date) {
        let calendarApi = this.$refs.calendar.getApi();
        calendarApi.gotoDate(moment(date).format("YYYY-MM-DD"));
      }
    },
    selectedDatePicker(date) {
      let calendarApi = this.$refs.calendar.getApi();
      calendarApi.gotoDate(date);
    },
    handleWaitItemDrop(evt) {
      // console.log(evt);
      let id = parseInt(evt.draggedEl.id);
      let wait_item = null;
      if (this.waitList && this.waitList.length > 0) {
        wait_item = this.waitList.find((item) => item.id == id);
      }

      let staff = null;
      let resource_id = parseInt(evt.resource.id);
      if (this.resources && this.resources.length > 0) {
        staff = this.resources.find((resource) => resource.id == resource_id);
        staff.user_id = staff.id;
      }
      let items = [];
      let start_time = {
        value:
          parseInt(moment(evt.date).format("HH")) * 3600 +
          parseInt(moment(evt.date).format("mm")) * 60,
        text: moment(evt.date).format("hh:mm a"),
      };
      if (wait_item.services && wait_item.services.length > 0) {
        for (let i = 0; i < wait_item.services.length; i++) {
          let service = JSON.parse(JSON.stringify(wait_item.services[i]));
          service.duration = 30;

          let item = {
            duration: { value: 30, text: "0h30m" },
            service: service,
            staff: staff,
            start_time:
              start_time.value + i * 30 * 60 > 77400
                ? { value: 77400, text: "9:30 pm" }
                : {
                    value: start_time.value + i * 30 * 60,
                    text: moment(start_time.text, "hh:mm a")
                      .add(30 * i, "minutes")
                      .format("hh:mm a"),
                  },
          };
          items.push(item);
        }
      } else {
        let item = {
          duration: { value: 30, text: "0h30m" },
          service: null,
          staff: staff,
          start_time:
            start_time.value > 77400
              ? { value: 77400, text: "9:30 pm" }
              : {
                  value: start_time.value,
                  text: moment(start_time.text, "hh:mm a")
                    .format("hh:mm a"),
                },
        };
        items.push(item);
      }
      let obj = {
        customer: wait_item.customer,
        date: moment(evt.date).format("YYYY-MM-DD"),
        items: items,
        from_wait_list: 1,
        checkin_id: wait_item.id,
        order_id: wait_item.order ? wait_item.order.id : null,
        note: "",
        // status: {}
      };
      // console.log(obj);
      this.$vs.loading({
        container: "#app",
        scale: 0.8,
      });
      if (wait_item.appointment) {
        obj.appointment_base_id = wait_item.appointment.id;
        obj.status = wait_item.appointment.status;
        console.log(obj);
        this.$store
          .dispatch("posAppointment/UPDATE_APPOINTMENT", obj)
          .then(() => {
            this.$vs.loading.close("#app > .con-vs-loading");
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.$vs.loading.close("#app > .con-vs-loading");
          });
      } else {
        console.log(obj);
        this.$store
          .dispatch("posAppointment/CREATE_APPOINTMENT", obj)
          .then(() => {
            this.$vs.loading.close("#app > .con-vs-loading");
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.$vs.loading.close("#app > .con-vs-loading");
          });
      }
    },
    async handleDateClick(arg) {
      // return;
      console.log("date");
      let calendarApi = this.$refs.calendar.getApi();
      if (calendarApi.view.type == "dayGridMonth") {
        calendarApi.gotoDate(arg.date);
        this.changeView("resourceTimeGridDay", "Day", "1d");
        return;
      }
      if (moment().format("X") > moment(arg.date).format("X")) {
        return;
      }
      if (arg.jsEvent.target.classList.contains("fc-nonbusiness")) {
        console.log("You've clicked outside business hour");
        this.$vs.dialog({
          color: "primary",
          title: "Appointment booking",
          text: "Can not schedule appointments outside your normal business hours!",
          acceptText: "OK",
        });
      } else if (arg.jsEvent.target.classList.contains("fc-bgevent")) {
        return;
      } else {
        await this.$vs.loading({
          container: "#app",
          scale: 0.8,
        });
        this.argPopup = arg;
        this.$store
          .dispatch("posAppointment/GET_APPOINTMENT_SPECIFIC_DATE", {
            date: moment(arg.date).format("YYYY-MM-DD"),
          })
          .then(() => {
            this.popupAddNewAppointment(arg);
            this.$vs.loading.close("#app > .con-vs-loading");
          })
          .catch((error) => {
            console.log(error);
            this.$vs.loading.close("#app > .con-vs-loading");
          });
      }
    },
    createOrder() {
      // this.$store.dispatch("posAppointment/CREATE_ORDER", {}).then((res) => {
      //   let object = {
      //     app: "pos-appointment",
      //     type: "click",
      //     action: "new-order",
      //     data: { order_id: res.id },
      //   };
      //   window.chrome.webview.postMessage(object);
      // });
      let object = {
        app: "pos-appointment",
        type: "click",
        action: "new-order",
        data: {},
      };
      if (typeof window.chrome.webview !== "undefined") {
        window.chrome.webview.postMessage(object);
      }
    },
    async handleEventClick(target) {
      // console.log(target.jsEvent.target.className);
      if (target.jsEvent.target.className != "pen-img") {
        if (target.event.rendering == "background") {
          if (target.event.extendedProps.service_id != null) {
            this.openConfirmBlockTime(target.event);
          } else {
            this.openBlockTimeAlert(target.event);
          }
        } else {
          await this.$vs.loading({
            container: "#app",
            scale: 0.8,
          });
          this.$store
            .dispatch("posAppointment/GET_APPOINTMENT_DETAIL", {
              id: target.event.id,
            })
            .then(() => {
              this.$store
                .dispatch("posAppointment/GET_APPOINTMENT_SPECIFIC_DATE", {
                  date: moment(target.event.start).format("YYYY-MM-DD"),
                  appointment_id: target.event.id,
                })
                .then(() => {
                  this.$vs.loading.close("#app > .con-vs-loading");
                  // this.openDetailPopup(target.event.id);
                  if (target.event.extendedProps.order) {
                    if (
                      target.event.extendedProps.order.order_status == 13 ||
                      target.event.extendedProps.order.order_status == 14 ||
                      target.event.extendedProps.order.order_status == 15 ||
                      target.event.extendedProps.order.order_status == 16
                    ) {
                      console.log("Open Detail Popup");
                      this.openDetailPopup(target.event.id, target.event.extendedProps.order.id);
                    } else {
                      // alert("Order id: " + target.event.extendedProps.order.id);
                      if (typeof window.chrome.webview !== "undefined") {
                        window.chrome.webview.postMessage({
                          app: "pos-appointment",
                          type: "click",
                          action: "update-order",
                          data: {
                            order_id: target.event.extendedProps.order.id,
                          },
                        });
                      }
                    }
                  } else {
                    // alert('Khong co order nha');
                    this.$store
                      .dispatch("posAppointment/CREATE_ORDER", {
                        appointment_id: parseInt(target.event.id),
                      })
                      .then((res) => {
                        // alert("Order id: " + res.id);
                        if (typeof window.chrome.webview !== "undefined") {
                          console.log(res.id);
                          window.chrome.webview.postMessage({
                            app: "pos-appointment",
                            type: "click",
                            action: "update-order",
                            data: { order_id: res.id },
                          });
                        }
                      });
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.$vs.loading.close("#app > .con-vs-loading");
                });
            });
        }
      }
    },

    handleEventDrop(target) {
      console.log(target);
      let oldResource = "";
      let newResource = "";
      if (target.oldResource != null && target.oldResource.title != null) {
        oldResource = target.oldResource.title;
      }
      if (target.newResource != null && target.newResource.title != null) {
        newResource = target.newResource.title;
      }

      let content =
        "Are you sure to update event from: " +
        moment(target.oldEvent.start).format("LLLL ") +
        (oldResource != "" ? "(" + oldResource + ")" : "") +
        " to: " +
        moment(target.event.start).format("LLLL ") +
        (newResource != "" ? "(" + newResource + ")" : "");
      ("?");
      this.$vs.dialog({
        color: "warning",
        title: `Confirmation!`,
        type: "confirm",
        text: content,
        accept: async () => {
          await this.$vs.loading({
            container: "#app",
            scale: 0.8,
          });
          let data = {
            event: {
              id: target.event.extendedProps.child_appointment_id,
              start: moment(target.event.start).format("YYYY-MM-DD HH:mm:ss"),
              end: moment(target.event.end).format("YYYY-MM-DD HH:mm:ss"),
            },
            resource: target.newResource != null ? target.newResource.id : null,
          };
          this.$store
            .dispatch("posAppointment/DRAG_DROP_UPDATE", data)
            .then(() => {
              this.$vs.loading.close("#app > .con-vs-loading");
            })
            .catch((error) => {
              console.log(error);
              target.revert();
              this.$vs.loading.close("#app > .con-vs-loading");
            });
        },
        cancel: () => {
          target.revert();
        },
      });
    },

    handleEventMouseEnter(event) {
      if (event.jsEvent.target.classList.contains("fc-bgevent")) {
        console.log("");
      } else {
        if (
          event.el &&
          event.el.firstChild &&
          event.event.extendedProps.note &&
          event.jsEvent.sourceCapabilities.firesTouchEvents == false
        ) {
          event.el.style.zIndex = 100;
          if (!event.el.firstChild.classList.contains("show-tooltip")) {
            event.el.firstChild.classList = "show-tooltip";
            let my_tooltip = document.createElement("div");
            my_tooltip.setAttribute("id", "my-tooltip-id");
            my_tooltip.classList.add("custom-calendar-tooltip");
            my_tooltip.innerText = event.event.extendedProps.note;

            event.el.firstChild.append(my_tooltip);
          }
        }
      }
    },

    handleEventMouseLeave(event) {
      if (event.jsEvent != null) {
        if (event.jsEvent.target.classList.contains("fc-bgevent")) {
          console.log("bg event");
        } else {
          event.el.style.zIndex = 1;
          let my_tooltip = document.getElementById("my-tooltip-id");
          if (my_tooltip && my_tooltip.parentNode) {
            my_tooltip.parentNode.classList.remove("show-tooltip");
            my_tooltip.parentNode.removeChild(my_tooltip);
          }
        }
      }
    },

    cancelWaitingItem(item) {
      console.log(item);
      alert("cancel waiting item..........");
    },

    changeActiveView(type) {
      if (this.active_view != type) {
        this.active_view = type;
        alert("change active view..........");
      }
    },

    changeActiveFilter(type) {
      if (this.active_filter != type) {
        this.active_filter = type;
        alert("change active filter..........");
      }
    },

    handleTurnClick() {
      alert("turn click............");
    },

    penClick(event) {
      // console.log('Pen click ne..........');
      // console.log('id:', event.target.id);
      let event_item = null;
      if (this.events && this.events.length > 0) {
        event_item = this.events.find((item) => item.id == event.target.id);
      }
      this.$store
        .dispatch("posAppointment/GET_APPOINTMENT_DETAIL", {
          id: event.target.id,
        })
        .then(() => {
          // let order_id = event.target.getAttribute('order-id') == null || event.target.getAttribute('order-id') == '' ? null : parseInt(event.target.getAttribute('order-id'));
          let order_id = event_item.order ? event_item.order.id : null;
          this.popupAddNew(null, event.target.id, order_id);
        });
    },

    // checkIconClick(event) {
    //   this.openDetailPopup(event.target.id);
    //   console.log(event.target.id);
    // },

    handleEventRender(event) {
      if (
        event.event.extendedProps.is_auto_assign &&
        event.event.extendedProps.is_auto_assign == 1
      ) {
        event.el.classList.add("bg-colorful");
      }

      // if (event.event.extendedProps.checkin == null || event.event.extendedProps.status == "done") {
      if (event.event.extendedProps.status == "done") {
        // event.el.classList.add("no-checkin");
        event.el.style.backgroundColor = `${event.event.backgroundColor}80`;
        event.el.style.borderColor = `${event.event.backgroundColor}80`;
      }

      // console.log(event.event)
      if(event.event.start) {
        let start = moment(event.event.start, 'HH:mm:ss');
        let end = event.event.end ? moment(event.event.end, 'HH:mm:ss') : start;
        let distance = (end.hours() * 60 + end.minutes()) - (start.hours() * 60 + start.minutes());
        if(distance < 30) {
          event.el.classList.add("title-hidden");
          event.el.classList.add("title-truncate-1");
        } else if (distance < 45) {
          event.el.classList.add("title-hidden");
          event.el.classList.add("title-truncate-4");
        }
      }

      if (
        event.event.extendedProps.order &&
        (event.event.extendedProps.order.order_status == 13 ||
          event.event.extendedProps.order.order_status == 14 ||
          event.event.extendedProps.order.order_status == 15 ||
          event.event.extendedProps.order.order_status == 16)
      ) {
        let check = document.createElement("img");
        check.src = "/white-check.png";
        check.classList.add("check-img");
        check.setAttribute("id", event.event.id);
        // check.addEventListener("click", this.checkIconClick);
        event.el.appendChild(check);
      } else {
        let pen = document.createElement("img");
        // if(event.event.extendedProps.checkin == null) {
        //   pen.src = "/black-pen.png";
        // } else {
        //   pen.src = "/white-pen.png";
        if (event.event.extendedProps.checkin == null) {
          pen.src =
            "https://dtsmart.sgp1.digitaloceanspaces.com/business/1/3l7Wcai4bscELAjnrZ8C7x3bHV1rPnyx.png";
        } else {
          pen.src =
            "https://s3-gci.nyc3.digitaloceanspaces.com/1/eQ7osCxQxSl1jCJHNCu4Rktn-Vuu0Mhl.png";
        }
        pen.classList.add("pen-img");
        pen.setAttribute("id", event.event.id);
        // pen.setAttribute('order-id', (event.event.extendedProps.order ? event.event.extendedProps.order.id : ''));
        pen.addEventListener("click", this.penClick);
        event.el.appendChild(pen);
      }

      if (event.event.extendedProps.order) {
        let order_id = document.createElement("div");
        // order_id.classList.add('fc-title');
        // order_id.classList.add('fc-sticky');
        order_id.innerText = `OD#${event.event.extendedProps.order.id}`;
        // order_id.style = "position: sticky; top: 0; left: 0; right: 0; width: max-content; display: block;";
        // if(event.el.childNodes && event.el.childNodes[0]) {
        //   event.el.childNodes[0].appendChild(order_id);
        // }
        order_id.classList.add("order-id-event");
        event.el.appendChild(order_id);
      }
    },

    openDetailPopup(id, order_id = null) {
      this.popupConfig = {
        appointmentId: id,
        order_id: order_id,
        isActive: true,
        key: this.popupConfig.key + 1,
      };
    },
    popupBlockTime() {
      this.popupBlockTimeConfig = {
        isActive: true,
        key: this.popupBlockTimeConfig.key + 1,
      };
    },
    popupAddNew(initDate = null, appointmentId = null, order_id = null) {
      this.popupEditConfig.key = this.popupEditConfig.key + 1;
      this.popupEditConfig.isActive = true;
      this.popupEditConfig.order_id = order_id;

      if (appointmentId) {
        this.popupEditConfig.appointmentId = appointmentId;
        this.popupEditConfig.isEdit = true;
      } else {
        this.popupEditConfig.appointmentId = null;
        this.popupEditConfig.isEdit = false;
      }
      if (initDate) {
        this.popupEditConfig.initDate = initDate.date;
        if (initDate.resource != null) {
          this.popupEditConfig.staff_id = initDate.resource.id;
        } else if (
          initDate.dayEl &&
          initDate.dayEl.dataset.resourceId !== undefined
        ) {
          this.popupEditConfig.staff_id = initDate.dayEl.dataset.resourceId;
        }
      }
    },
    popupAddNewAppointment(arg) {
      this.popupEditConfigBase.key = this.popupEditConfigBase.key + 1;
      this.popupEditConfigBase.isActive = true;
      // this.popupEditConfigBase.order_id = order_id;
      this.popupEditConfigBase.appointmentId = null;
      this.popupEditConfigBase.isEdit = false;
      if (arg) {
        this.popupEditConfigBase.initDate = arg.date;
        if (arg.resource != null) {
          this.popupEditConfigBase.staff_id = arg.resource.id;
        } else if (arg.dayEl && arg.dayEl.dataset.resourceId !== undefined) {
          this.popupEditConfigBase.staff_id = arg.dayEl.dataset.resourceId;
        }
      }
    },
    async closeEditPopupBase() {
      await this.$store.dispatch("posAppointment/RELOAD_CALENDAR");
      this.popupEditConfigBase.isActive = false;
    },
    closePopupFromIcon() {
      this.popupEditConfigBase.isActive = false;
    },
    closeEditPopup(data) {
      if (data.appointment_id != null && data.appointment_id != false) {
        this.$store
          .dispatch("posAppointment/GET_APPOINTMENT_DETAIL", {
            id: data.appointment_id,
          })
          .then(() => {
            this.openDetailPopup(data.appointment_id);
          });
      } else if (data.reopen == true) {
        this.openDetailPopup(this.appointmentDetail.id);
      }
      this.popupEditConfig.isActive = false;
    },
    closePopup() {
      this.popupConfig.isActive = false;
    },
    closeBlockTimePopup() {
      this.popupBlockTimeConfig.isActive = false;
    },
    async changeView(type, name, range) {
      let calendarApi = this.$refs.calendar.getApi();
      this.currentView = {
        name: name,
        value: type,
        type: range,
      };
      if (
        this.currentView.value == "timeGridThreeDay" ||
        this.currentView.value == "resourceTimeGridDay" ||
        this.currentView.value == "timeGridWeek"
      ) {
        this.editable = true;
      } else {
        this.editable = false;
      }
      calendarApi.changeView(this.currentView.value);
    },

    // onCalendarScroll() {
    //   let my_header = document.querySelector('.my-table-header .fc-scroller');
    //   let head = document.querySelector('.fc-head .fc-time-area .fc-scroller');
    //   my_header.scrollLeft = head.scrollLeft;
    // },

    // setMyCalendarTableHeader() {
    //   let before_item = document.querySelector('.my-table-header');
    //   if(before_item) {
    //     before_item.remove();
    //   }
    //   let container = document.querySelector('.fc-view-container');
    //   let my_header = document.createElement('div');
    //   my_header.classList.add('my-table-header');
    //   // my_header.style = "position: absolute; top: 0; left: calc(30% + 3px); width: calc(70% - 10px); height: max-content; background: #fff; z-index: 1; pointer-events: none;";

    //   let head = document.querySelector('.fc-head .fc-time-area .fc-scroller-clip');
    //   let clone_header = head.cloneNode(true);

    //   my_header.appendChild(clone_header);
    //   container.appendChild(my_header);

    //   // scroll
    //   this.onCalendarScroll();
    //   let head_scroll = document.querySelector('.fc-head .fc-time-area .fc-scroller');
    //   head_scroll.addEventListener('scroll', this.onCalendarScroll);
    // },
    // eslint-disable-next-line
    async datesRender(info) {
      // this.getElementPosition();
      let calendarApi = this.$refs.calendar.getApi();
      // console.log(calendarApi)
      this.change_date_value_key++;
      await this.$vs.loading({
        container: "#app",
        scale: 0.8,
      });
      this.currentDate = calendarApi.view.currentStart;
      await this.$store
        .dispatch("posAppointment/RELOAD_CALENDAR", {
          // type: this.currentView.type,
          start_time: moment(calendarApi.view.currentStart).format(
            "YYYY-MM-DD"
          ),
          // status: this.string_params,
        })
        .then(() => {
          let isExist = false;
          if (this.selectedResource != null) {
            if (this.resources.length > 0) {
              for (let i = 0; i < this.resources.length; i++) {
                if (this.resources[i].id == this.selectedResource.id) {
                  isExist = true;
                  break;
                }
              }
            } else {
              this.selectSource();
            }
          }
          if (isExist == false) {
            this.selectSource();
          }
          setTimeout(() => {
            calendarApi.rerenderEvents();
            if (this.interval == null) {
              this.interval = setInterval(this.lastRecord, 10000);
            }

            // this.setMyCalendarTableHeader();
            // setInterval(this.setMyCalendarTableHeader, 1000);

            // this.wait_list_key++;

            this.$vs.loading.close("#app > .con-vs-loading");
            this.setPositionOfMiniCalendar();
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close("#app > .con-vs-loading");
        });
    },
    editAppointment(id) {
      this.popupConfig.isActive = false;
      this.popupAddNew(null, id);
    },
    selectSource(item = null) {
      if (item != null) {
        this.$store.dispatch("posAppointment/SELECT_RESOURCE", item);
      } else {
        this.$store.dispatch("posAppointment/SELECT_RESOURCE");
      }
    },
    openConfirmBlockTime(event) {
      this.promptContent = this.selectedResource
        ? this.selectedResource.title
        : "This staff" +
          " is set up as busy at this time, do you still want to proceed? " +
          (event.extendedProps.note != ""
            ? "Note: " + event.extendedProps.note
            : "");
      this.activePrompt = true;
      this.promptEvent = event;
    },
    openBlockTimeAlert(event) {
      this.$vs.notify({
        title: "Alert",
        text:
          "Blocked with note: " +
          event.extendedProps.note +
          ', please navigate to "Block time setting" to remove it!',
        color: "warning",
        position: "top-right",
      });
    },
    acceptAlert() {
      let arg = {
        date: this.promptEvent.start,
        resource: {
          id: this.promptEvent._def.resourceIds[0]
            ? this.promptEvent._def.resourceIds[0]
            : null,
        },
      };
      this.$store
        .dispatch("posAppointment/GET_APPOINTMENT_SPECIFIC_DATE", {
          date: moment(this.promptEvent.start).format("YYYY-MM-DD"),
        })
        .then(() => {
          this.popupAddNew(arg);
          this.$vs.loading.close("#app > .con-vs-loading");
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close("#app > .con-vs-loading");
        });
    },
    deleteAlert() {
      let data = { id: this.promptEvent.id };
      this.$store
        .dispatch("posAppointment/DELETE_BLOCK_TIME", data)
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Deleted Block time successfully!",
            color: "success",
            position: "top-right",
          });
          this.closePopup();
          this.$vs.loading.close("#app > .con-vs-loading");
        })
        .catch(() => {
          this.$vs.notify({
            title: "Fail",
            text: "Delete Block time failed!",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close("#app > .con-vs-loading");
        });
    },
    getDomain() {
      let temp = domain;
      if (domain[domain.length - 1] == "/") {
        temp = domain.slice(0, -1);
      }
      return temp.substring(temp.lastIndexOf("/") + 1);
    },
    subscribeTopic() {
      let topics = [
        "/v1/appointment",
        "/v1/appointment/appointment",
        "/v1/appointment/booking",
        "/v1/gocheckin/checkin",
        "/v1/gocheckin/checkout",
      ];
      let hubUrl = "";
      let jwt = "";
      if (process.env.NODE_ENV == "development") {
        hubUrl = process.env.VUE_APP_DEVELOPMENT_MERCURE_HUB_URL;
        jwt = process.env.VUE_APP_DEVELOPMENT_MERCURE_JWT;
      } else {
        let mercure = JSON.parse(localStorage.getItem("appMercure"));
        hubUrl = mercure.hub_url;
        jwt = mercure.jwt;
      }
      const option = {
        headers: {
          Authorization: "Bearer " + jwt,
        },
      };
      let id = md5(client_id);
      // console.log(id);

      const u = new URL(hubUrl);
      topics.forEach((topic) => {
        u.searchParams.append("topic", id + "/" + this.getDomain() + topic);
      });
      this.eventSource = new EventSourcePolyfill(u, option);
      this.eventSource.onmessage = (e) => {
        this.dataChange.message = JSON.parse(e.data);
        this.dataChange.key++;
        // console.log(this.dataChange)
      };
    },
    async selectFilter(type) {
      let calendarApi = this.$refs.calendar.getApi();
      await this.$vs.loading({
        container: "#app",
        scale: 0.8,
      });
      switch (type) {
        case "scheduled": {
          this.filter_scheduled = !this.filter_scheduled;
          break;
        }
        case "confirmed": {
          this.filter_confirmed = !this.filter_confirmed;
          break;
        }
        case "done": {
          this.filter_done = !this.filter_done;
          break;
        }
        case "canceled": {
          this.filter_canceled = !this.filter_canceled;
          break;
        }
        case "clear": {
          this.filter_scheduled = true;
          this.filter_done = true;
          this.filter_confirmed = true;
          this.filter_canceled = false;
          break;
        }
      }
      this.string_params = "";

      if (
        this.filter_scheduled == false &&
        this.filter_confirmed == false &&
        this.filter_canceled == false &&
        this.filter_done == false
      ) {
        this.filter_scheduled = true;
        this.filter_done = true;
        this.filter_confirmed = true;
        this.filter_canceled = false;
      }

      if (this.filter_scheduled == true) {
        this.string_params += "scheduled,";
      }
      if (this.filter_confirmed == true) {
        this.string_params += "confirmed,";
      }
      if (this.filter_done == true) {
        this.string_params += "done,";
      }
      if (this.filter_canceled == true) {
        this.string_params += "canceled,";
      }
      if (this.string_params != "") {
        this.string_params = this.string_params.slice(0, -1);
      }

      await this.$store
        .dispatch("posAppointment/RELOAD_CALENDAR", {
          // type: this.currentView.type,
          start_time: moment(calendarApi.view.currentStart).format(
            "YYYY-MM-DD"
          ),
          // status: this.string_params,
        })
        .then(() => {
          setTimeout(() => {
            calendarApi.rerenderEvents();
            this.$vs.loading.close("#app > .con-vs-loading");
            // this.wait_list_key++;
          }, 1000);
        })
        .catch(() => {
          calendarApi.rerenderEvents();
          this.$vs.loading.close("#app > .con-vs-loading");
        });
    },
    lastRecord() {
      // this.setMyCalendarTableHeader();
      if (typeof this.$refs.calendar !== "undefined") {
        let calendarApi = this.$refs.calendar.getApi();
        this.$store
          .dispatch("posAppointment/CHECK_UPDATE", {
            type: this.currentView.type,
            start_time: moment(calendarApi.view.currentStart).format(
              "YYYY-MM-DD"
            ),
            status: this.string_params,
          })
          .then((lastAppointment) => {
            if (lastAppointment) {
              if (this.lastAppointment == null) {
                this.lastAppointment = lastAppointment;
                return;
              } else if (this.lastAppointment.id != lastAppointment.id || this.lastAppointment.updated_at != lastAppointment.updated_at) {
                this.$store.dispatch("posAppointment/RELOAD_CALENDAR");
              }
              this.lastAppointment = lastAppointment;
            }
          });

        this.$store.dispatch("checkin/CHECK_UPDATE").then((isUpdated) => {
          if (isUpdated) {
            this.$store.dispatch("posAppointment/RELOAD_CALENDAR");
          }
        });
      } else {
        clearInterval(this.interval);
        this.interval = null;
        return;
      }
    },
  },
  destroyed() {
    this.eventSource.close();
    clearInterval(this.interval);
    this.doUnSubscribe();
  },
};
</script>
